import React from 'react';
import { Button } from '../../utils';

const Index = ({ title, cta, Icon, description }) => {
  return (
    <div className="max-w-full lg:max-w-[450px]">
      <div className="flex flex-col items-center justify-center">
        {Icon && Icon}
        <h3 className="font-bold pt-[16.45px] pb-[10.38px] text-subheadingColor leading-[48px] text-[40px] font-Inter">
          {title}
        </h3>
        {description && (
          <p className="text-base font-normal leading-6 text-center font-Inter text-textColor">
            {description}
          </p>
        )}
        <Button
          text="Re-send Link"
          type="submit"
          bg="bg-primary1"
          border="border-primary1"
          color="text-white"
          className="w-full h-[48px] justify-center font-semibold"
          cta={() => {
            if (cta) {
              cta();
            }
          }}
        />
      </div>
    </div>
  );
};

export default Index;
